import { render, staticRenderFns } from "./newsArticleTemplate.vue?vue&type=template&id=2d8620e8&"
import script from "./newsArticleTemplate.vue?vue&type=script&lang=js&"
export * from "./newsArticleTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports